import { DakokuDataFull } from "@/types/Dakoku";
import { DateUtil } from "@/utils/DateUtil";
import { reactive, ref } from "vue";

export interface DakokuSyouninData {
  dakokuId: number | null,
  date: string,
  status: number | null,
  syouninNotes: string,
}

export function useDakokuSyouninModal() {
  const dakokuSyouninModalRef = ref()
  const syouninData: DakokuSyouninData = reactive({
    dakokuId: null,
    date: '',
    status: null,
    syouninNotes: '',
  })

  const comment = ref('') // 否認理由等コメント

  const setData = async (dakokuData: DakokuDataFull) => {
    console.log('setData -> syouninTarget:', dakokuData)
    if (!dakokuData) {
      return
    }


    syouninData.dakokuId = dakokuData.dakoku_id
    syouninData.date = DateUtil.format(dakokuData.dakoku_date!)
    syouninData.status = dakokuData.syounin_status_type
    syouninData.syouninNotes = dakokuData.syounin_status_notes

    console.log('setData', dakokuData)
  }

  const clearData = async () => {
    syouninData.dakokuId = null;
    syouninData.date = '';
    syouninData.status = null;
    syouninData.syouninNotes = '';
    console.log('clearData', syouninData)
  }

  const dakokuSyouninModalParts = reactive({
    title: '打刻情報の承認',
    button: ''
  })

  const openDakokuSyouninModal = () => {
    dakokuSyouninModalRef.value.open()
  }

  const closeDakokuSyouninModal = () => {
    dakokuSyouninModalRef.value.close()
  }

  return {
    dakokuSyouninModalRef,
    openDakokuSyouninModal,
    closeDakokuSyouninModal,
    dakokuSyouninModalParts,
    setData,
    clearData,
    syouninData
  }
}
